/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSearch } from 'wouter';

import useCollections from '../../hooks/useCollections';
import useFiltersQuery from '../../hooks/useFiltersQuery';
import useScrollEnter from '../../hooks/useScrollEnter';
import { usePageViewTracking } from '../../hooks/useTracking';

import { useBrand, useDefaultBrand } from '../../contexts/SiteContext';
import CollectionsRowBlock from '../blocks/CollectionsRowBlock';
import IndexDefaultHeader from '../headers/IndexDefaultHeader';
import InfiniteItemsBlocks from '../lists/InfiniteItemsBlocks';
import IndexFilters from '../partials/IndexFilters';
import RowTitle from '../partials/RowTitle';

import styles from '../../styles/pages/videos-page.module.css';

const propTypes = {
    brandSlug: PropTypes.string,
    current: PropTypes.bool,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    onEnter: PropTypes.func,
    onLeave: PropTypes.func,
};

const defaultProps = {
    brandSlug: null,
    current: false,
    className: null,
    contentClassName: null,
    onEnter: null,
    onLeave: null,
};

function VideosPage({ brandSlug, current, className, contentClassName, onEnter, onLeave }) {
    const filters = useFiltersQuery();
    const hasBrand = brandSlug !== null;
    const { handle: defaultBrandHandle = 'urbania' } = useDefaultBrand();
    const brand = useBrand(brandSlug, !hasBrand ? defaultBrandHandle : null);
    const { handle: brandHandle = null } = brand || {};

    const search = useSearch();
    const { sort: sortQuery = null } = useMemo(() => queryString.parse(search), [search]);

    useScrollEnter({
        disabled: !current,
        onEnter,
        onLeave,
    });

    usePageViewTracking(current, {
        brand,
        pageType: 'index',
    });

    const { items: collections = null } = useCollections({
        brand: brand.id,
        type: 'serie',
    });

    const hasCollections = collections !== null && collections.length > 0;

    return (
        <div
            className={classNames([styles.container, className, contentClassName])}
            data-brand={brandHandle}
        >
            <IndexDefaultHeader
                title={<FormattedMessage defaultMessage="Vidéos" description="Page title" />}
                className={styles.header}
            />
            <IndexFilters
                route="videos"
                sort={sortQuery}
                brand={brand}
                className={styles.filters}
            />
            <main className={styles.content}>
                {hasCollections ? (
                    <>
                        <CollectionsRowBlock
                            title={
                                <RowTitle className={styles.title}>
                                    <FormattedMessage
                                        defaultMessage="Séries"
                                        description="Row title"
                                    />
                                </RowTitle>
                            }
                            presentation="grid"
                            items={collections}
                            withoutLoader
                            cardType="vertical"
                            cardRatio="vertical"
                            // cardSize="big"
                            cardWithout={['brand-icon', 'text']}
                            cardTheme="box-translucent"
                            className={styles.series}
                        />
                        <RowTitle className={styles.sectionTitle}>
                            <FormattedMessage defaultMessage="Vidéos" description="Row title" />
                        </RowTitle>
                    </>
                ) : null}
                <InfiniteItemsBlocks
                    query={{
                        type: 'video',
                        brand: brand.id,
                        ...filters,
                    }}
                    // itemsBlocks={[
                    //     {
                    //         type: 'items',
                    //         itemsType: 'documents',
                    //         presentation: 'grid',
                    //         cardType: 'vertical',
                    //         // cardRatio: 'vertical',
                    //         cardTheme: 'box-translucent',
                    //         cardWidth: 250,
                    //         cardWithout: brandSlug !== null ? ['brand-icon'] : [],
                    //         cardSize: {
                    //             large: null,
                    //             medium: null,
                    //             default: 'small',
                    //         },
                    //         // cardSize: 'big',
                    //         fixedColumns: [2, 3, 4, 6],
                    //         count: 12,
                    //     },
                    //     {
                    //         type: 'items',
                    //         itemsType: 'documents',
                    //         presentation: 'row',
                    //         cardType: 'over',
                    //         cardRatio: 'vertical',
                    //         cardTheme: 'outline',
                    //         cardWidth: 300,
                    //         cardWithout: brandSlug !== null ? ['brand-icon'] : [],
                    //         // cardSize: 'big',
                    //         fixedColumns: [2, 3, 4, 6],
                    //         count: 12,
                    //     },
                    // ]}
                    cardWithout={['brand-icon']}
                />
            </main>
        </div>
    );
}

VideosPage.propTypes = propTypes;
VideosPage.defaultProps = defaultProps;

export default VideosPage;
